var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43094e-07 17C7.0617e-07 16.1553 0.497409 15.3106 0.994818 14.8882L17.4093 0.95031C18.9016 -0.316771 21.3886 -0.316771 22.8808 0.95031C24.3731 2.21739 24.3731 4.32919 22.8808 5.59627L9.45078 17L22.8808 28.4037C24.3731 29.6708 24.3731 31.7826 22.8808 33.0497C21.3886 34.3168 18.9016 34.3168 17.4093 33.0497L1.49223 19.5342C0.497411 18.6894 7.80018e-07 17.8447 7.43094e-07 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.174b40ac4d8666c21f5ec09a3310c4de.svg";
export { ForwardRef as ReactComponent };